module.exports = __webpack_public_path__ + "static/docsFrontDesktop@2x-616d1e1e2b5bd3f58c5a0e51820f9cfb.png";